import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { setSelectedNode } from '../../../features/networkSlice';
import { setNodes } from '../../../features/networkUndoSlice';
import { sameId } from '../../../lib/model';
import { handleAltArrowReorder } from './reorderShortcut';

function CustomFilter() {
  return <GridToolbarQuickFilter sx={{ p: 2 }} />;
}

const columns = [
  { field: 'id', headerName: 'ID', flex: 1 },
  { field: 'label', headerName: 'Label', flex: 3, valueGetter: ({ row }) => row.label || String(row.id) },
  { field: 'description', headerName: 'Description', flex: 6, valueGetter: ({ row }) => row.description || row.title || '' },
];
const initialState = { pagination: { paginationModel: { pageSize: 50 } } };

export default function NodesTable(props) {
  const { visible } = props; // indicates if the tab is visible (otherwise DataGrid will complain)
  const nodes = useSelector((state) => state.networkUndo.present.nodes);
  const edges = useSelector((state) => state.networkUndo.present.edges);

  const highlightedNodes = useSelector((state) => state.network.highlightedNodes) || [];
  const highlightedEdges = useSelector((state) => state.network.highlightedEdges) || [];

  // when only links are selected, show the nodes at either end
  let connectedNodes = [];
  if (highlightedNodes.length === 0) {
    connectedNodes = highlightedEdges.flatMap((edgeId) => {
      const edge = edges.find((item) => sameId(item.id, edgeId));
      return edge ? [edge.to, edge.from] : [];
    });
  }

  const filteredNodes = nodes.filter((node) => {
    if (highlightedNodes.length === 0 && highlightedEdges.length === 0) return true;
    if (highlightedNodes.some((id) => sameId(id, node.id))) return true;
    return connectedNodes.some((id) => sameId(id, node.id));
  });

  const dispatch = useDispatch();

  const onRowClick = (e) => { // 'onRowDoubleClick' also available
    dispatch(setSelectedNode(e.row));
  };

  return (visible && (
    <>
      <DataGrid
        autoHeight
        getRowHeight={() => 'auto'}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            alignItems: 'start',
            py: 1,
          },
          border: 0,
        }}
        rows={filteredNodes}
        columns={columns}
        initialState={initialState}
        onRowDoubleClick={onRowClick}
        onCellKeyDown={(params, event) => handleAltArrowReorder(
          nodes,
          params.row.id,
          event,
          dispatch,
          setNodes,
        )}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25, 50]}
        slots={{ toolbar: CustomFilter }}
      />
      {(highlightedEdges.length > 0 || highlightedNodes.length > 0) && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          The rows are filtered based on selections
        </Alert>
      )}
    </>
  ));
}
